import { SET_DIGITAL_CORE_DATA } from "../actions/digitalCoreActions";

const initialState = {
  data: null,
  status: "idle",
  error: null,
};

const digitalCoreReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DIGITAL_CORE_DATA:
      return { ...state, data: action.payload, status: "success" };
    default:
      return state;
  }
};

export default digitalCoreReducer;
